export default function ExcelDownload() {
  return (
 <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_2)">
    <path d="M45 13.125H88.125V76.875H45V13.125Z" fill="white"/>
    <path d="M88.125 78.75H50.625C49.5886 78.75 48.75 77.9114 48.75 76.875C48.75 75.8386 49.5886 75 50.625 75H86.25V15H50.625C49.5886 15 48.75 14.1614 48.75 13.125C48.75 12.0886 49.5886 11.25 50.625 11.25H88.125C89.1614 11.25 90 12.0886 90 13.125V76.875C90 77.9114 89.1614 78.75 88.125 78.75Z" fill="#177848"/>
    <path d="M52.5 0L0 9.78261V80.2174L52.5 90V0Z" fill="#177848"/>
    <path opacity="0.2" d="M0 9.78264V10.7201L52.5 0.9375V0L0 9.78264Z" fill="white"/>
    <path d="M48.75 18.75H63.75V26.25H48.75V18.75Z" fill="#177848"/>
    <path d="M67.5 18.75H82.5V26.25H67.5V18.75Z" fill="#177848"/>
    <path d="M48.75 30H63.75V37.5H48.75V30Z" fill="#177848"/>
    <path d="M67.5 30H82.5V37.5H67.5V30Z" fill="#177848"/>
    <path d="M48.75 41.25H63.75V48.75H48.75V41.25Z" fill="#177848"/>
    <path d="M67.5 41.25H82.5V48.75H67.5V41.25Z" fill="#177848"/>
    <path d="M48.75 52.5H63.75V60H48.75V52.5Z" fill="#177848"/>
    <path d="M67.5 52.5H82.5V60H67.5V52.5Z" fill="#177848"/>
    <path d="M48.75 63.75H63.75V71.25H48.75V63.75Z" fill="#177848"/>
    <path d="M67.5 63.75H82.5V71.25H67.5V63.75Z" fill="#177848"/>
    <path opacity="0.1" d="M0 80.2173L52.5 90V89.0625L0 79.2798V80.2173Z" fill="black"/>
    <path d="M88.125 78.75C89.1614 78.75 90 77.9114 90 76.875V48.75L52.5 11.25V78.75H88.125Z" fill="url(#paint0_linear_2_2)"/>
    <path d="M27.5912 46.875L36.2073 31.366L36.0985 31.3055L29.5486 31.7734L24.375 41.0859L19.5962 32.4843L13.4095 32.926L21.1587 46.875L13.4095 60.824L19.5962 61.2657L24.375 52.6641L29.5486 61.9766L36.0985 62.4445L36.2073 62.384L27.5912 46.875Z" fill="white"/>
    <path opacity="0.05" d="M52.5 0L0 9.78261V80.2174L52.5 90V0Z" fill="url(#paint1_linear_2_2)"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_2_2" x1="35.625" y1="28.125" x2="87.5775" y2="80.0775" gradientUnits="userSpaceOnUse">
    <stop stopOpacity="0.1"/>
    <stop offset="1" stopOpacity="0"/>
    </linearGradient>
    <linearGradient id="paint1_linear_2_2" x1="-0.49701" y1="45.6904" x2="52.0948" y2="45.6904" gradientUnits="userSpaceOnUse">
    <stop stopColor="white"/>
    <stop offset="1"/>
    </linearGradient>
    <clipPath id="clip0_2_2">
    <rect width="90" height="90" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    
  );
}
